import { ReactComponent as Icon } from "./delete.svg";

const DeleteIcon = () => {
    return <Icon />;
}

export default DeleteIcon;